<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <p v-if="vending.catalog.length === 0">
      {{ $t("vending.noCategoriesCreated") }}
    </p>

    <div v-else v-for="(c, i) in vending.catalog" :key="c._id">
      <p style="margin-bottom: 0.5rem;">
        <b>{{ c.name }}</b>
      </p>

      <p v-if="c.products.length === 0">
        {{ $t("vending.categoryHasNoProducts") }}
      </p>

      <div
        v-else
        v-for="p in c.products"
        :key="p.b"
        style="margin-bottom: 1rem;"
      >
        <p
          style="margin-bottom: 0.75rem;"
          :style="p.p === 0 || p.sl.length === 0 ? 'color: red' : ''"
        >
          {{
            `${p.b} - ${p.n} ${
              p.p === 0 || p.sl.length === 0
                ? `--> Produto sem preço e/ou sem slots definidos`
                : ""
            }`
          }}
        </p>

        <div class="columns is-variable is-1">
          <div class="column is-narrow">
            <b-field :label="$t('vending.price')" label-position="on-border">
              <money
                v-model="p.p"
                v-bind="money"
                class="input is-expanded"
                style="width: 100px"
                @focus.native="saveOriginalValue(p.p)"
                @blur.native="checkSave(p.p, p)"
                :disabled="
                  vendingBeingManaged.vendingInfo.isCacauShow &&
                    !companyInfo.isCacauShowHeadquarter
                "
              ></money>
            </b-field>
          </div>

          <div class="column is-narrow">
            <b-field :label="$t('vending.idealQty')" label-position="on-border">
              <b-input
                type="tel"
                v-model="p.iq"
                style="width: 70px"
                @focus="saveOriginalValue(p.iq)"
                @blur="checkSave(p.iq, p)"
                :disabled="vendingBeingManaged.vendingInfo.isCacauShow"
              ></b-input>
            </b-field>
          </div>

          <div class="column is-narrow">
            <b-field
              :label="$t('vending.currentQty')"
              label-position="on-border"
            >
              <b-input
                type="tel"
                v-model="p.cq"
                style="width: 70px"
                disabled
              ></b-input>
            </b-field>
          </div>

          <div
            class="column is-narrow"
            v-if="!vendingBeingManaged.vendingInfo.isCacauShow"
          >
            <button
              class="button"
              style="padding-right: 10px;"
              @click="addSlot(p)"
            >
              <b-icon
                icon="plus-circle"
                type="is-info"
                style="position: relative; right: 6px;"
              ></b-icon>
              {{ $t("vending.slot") }}
            </button>
          </div>

          <div class="column is-narrow" v-for="(s, i) in p.sl" :key="s.n">
            <b-field
              :label="
                `${$t('vending.slot')} ${s.d ? `${s.n}/${s.n + 1}` : s.n}`
              "
              label-position="on-border"
            >
              <b-input
                type="tel"
                v-model="s.cq"
                style="width: 70px"
                @input="calculateCq(p, s.cq)"
                @focus="saveOriginalValue(s.cq)"
                @blur="checkSave(s.cq, p)"
              ></b-input>

              <p
                class="control"
                v-if="!vendingBeingManaged.vendingInfo.isCacauShow"
              >
                <button
                  class="button is-small"
                  style="height: 100%;"
                  @click="editSlot(p, s, i)"
                >
                  <b-icon icon="pen" size="is-small"></b-icon>
                </button>
              </p>
            </b-field>
          </div>
        </div>
      </div>

      <hr v-if="i < vending.catalog.length - 1" />
    </div>

    <b-modal :active.sync="slotModalVisible">
      <slot-modal
        :product="product"
        :vending="vending"
        :operation="operation"
        :slotInfo="slotInfo"
        :slotIndex="slotIndex"
        @update-vending="updateVending"
        @show-save-changes-button="$emit('show-save-changes-button')"
      />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { Money } from "v-money";
import slotModal from "./SlotModal";

export default {
  mixins: [common],

  components: {
    Money,
    slotModal
  },

  data() {
    return {
      vending: {
        vendingInfo: {},
        catalog: [],
        products: []
      },
      isLoading: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2
      },
      slotModalVisible: false,
      product: null,
      slotInfo: null,
      slotIndex: null,
      operation: null,
      originalValue: null
    };
  },

  methods: {
    updateVending() {
      this.vending = this.vendingBeingManaged;
    },

    addSlot(product) {
      this.product = product;
      this.operation = "add";
      this.slotModalVisible = true;
    },

    editSlot(product, slotInfo, slotIndex) {
      this.product = product;
      this.slotInfo = slotInfo;
      this.slotIndex = slotIndex;
      this.operation = "edit";
      this.slotModalVisible = true;
    },

    calculateCq(p) {
      p.cq = p.sl.reduce((t, n) => {
        return t + Number(n.cq);
      }, 0);
    },

    saveOriginalValue(v) {
      this.originalValue = v;
    },

    checkSave(v, p) {
      if (v !== this.originalValue) {
        this.$store.commit("UPDATE_VENDING_PRODUCT", {
          product: p,
          vendingId: this.vendingBeingManaged._id
        });
        this.updateVending();
        this.$emit("show-save-changes-button");
      }
    }
  },

  computed: {
    ...mapGetters(["vendingBeingManaged", "payments", "companyInfo"])
  },

  mounted() {
    this.updateVending();

    this.money.prefix = `${this.payments.currencySymbol} `;
  }
};
</script>
